import { ChangeEvent, FormEvent, FunctionComponent, useState } from 'react';

import { getErrorsFromRequest } from 'utils/api';

import { resetPassword as resetPasswordRequest } from 'requests/user';

import Button from 'components/layout/Button';
import { ButtonTypes } from 'components/layout/Button/types';
import Form from 'components/layout/forms/Form';
import Input from 'components/layout/forms/Input';

import StyledComponent from './styles';
import { Props } from './types';

interface FormState {
    email: string;
}

interface Errors extends FormState {};

const ContentSectionsSendLinkToPassReset: FunctionComponent<Props> = ({ translations, onSuccess }) => {
    const [formValues, setFormValues]: [FormState, Function] = useState(null);
    const [errorMessage, setErrorMessage]: [Errors, Function] = useState(null);

    const submitForm = (event:FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        resetPasswordRequest({ ...formValues })
            .then(() => onSuccess && onSuccess())
            .catch((errors) => setErrorMessage(getErrorsFromRequest(errors)));
    };

    return (
        <StyledComponent className="content-section-company-register">
            <Form
                onSubmit={submitForm}
                className="password-reset-form"
            >
                <Input
                    name='email'
                    label={translations?.inputMail}
                    placeholder={translations?.inputMail}
                    onChange={(e:ChangeEvent<HTMLInputElement>) => setFormValues({ email: e.target.value })}
                    value={formValues?.email}
                    error={errorMessage?.email}
                />
                <Button
                    className="submit-button"
                    type={ButtonTypes.Submit}
                >
                    {translations?.submitButton}
                </Button>
            </Form>
        </StyledComponent>
    );
};

export default ContentSectionsSendLinkToPassReset;